export const BRAZE_FOLLOW_EVENT = 'follow_event';
export const BRAZE_UNFOLLOW_EVENT = 'unfollow_event';
export const BRAZE_PLAY_EVENT = 'play_event';
